import { Injectable } from '@angular/core';
import { IRolePermisssionModel } from '@models/module/module.model';
import { DELETE, MANAGE, VIEW } from '@core/constants/permission.const';
import { CurrentUserService } from './currentuser.service';
import { AppModulePath } from '@core/constants/app-module-path.const';
import { ICurrentUserModel } from '@models/auth/auth.model';
import { UserType } from '@core/enums/type.enum';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  constructor(private currentUserService: CurrentUserService) {}

  checkAppModuleAccess = (path: string) => {
    let moduleName = '';
    AppModulePath.map((module) => {
      if (module?.accessiblePaths?.length > 0) {
        const isPathMatch = module?.accessiblePaths?.find(
          (accessiblePath: string) => path?.includes(accessiblePath)
        );
        if (isPathMatch) moduleName = module?.moduleName;
        else return;
      }
    });

    const currentUser: ICurrentUserModel = this.currentUserService.get();
    if (currentUser?.userTypeId === UserType.SuperAdmin) return true;
    const permission = currentUser?.permissions?.find(
      (permission: IRolePermisssionModel) =>
        permission?.ModuleName === moduleName
    );
    return permission?.CanView;
  };

  checkAppModulePermission = (module: string, permission: string) => {
    const currentUser: ICurrentUserModel = this.currentUserService.get();
    if (currentUser?.userTypeId === UserType.SuperAdmin) return true;
    const rolPermission = currentUser?.permissions?.find(
      (permission: IRolePermisssionModel) => permission?.ModuleName === module
    );

    switch (permission) {
      case VIEW:
        return rolPermission?.CanView;
      case MANAGE:
        return rolPermission?.CanManage;
      case DELETE:
        return rolPermission?.CanDelete;
    }
    return false;
  };

  checkAppModuleActionPermissions = (
    module: string,
    permissions: string[]
  ): boolean => {
    const currentUser: ICurrentUserModel = this.currentUserService.get();
    if (currentUser?.userTypeId === UserType.SuperAdmin) return true;

    const rolPermission = currentUser?.permissions?.find(
      (permission: IRolePermisssionModel) => permission?.ModuleName === module
    );

    if (!rolPermission) return false;

    return permissions.some(
      (permission) =>
        (permission === MANAGE && rolPermission.CanManage) ||
        (permission === DELETE && rolPermission.CanDelete)
    );
  };
}
